/* AP · Tarot leaderboard — Halloween Private Sale "Top 30 win a Halloween set".
 * Markup: snippets/ap-tarot-leaderboard.liquid (templates/page.tarot-leaderboard.json).
 * GET /apps/afp-analytics/tarot/leaderboard?sid=<s-id>  (s-id from the URL or localStorage ap_tarot_sid)
 *   -> { ok:true, updatedAt, endsAt, cutoff|null, top:[{rank,name,place,points}] (<=35; 31-35 sit below the line),
 *        me:{points,rank}|null, day, lastNight:{day, top:[30 rows]}|null }  (owner 03/10: one race per PT day)
 * Owner 04/10: + topN (5 on Sunday "The Midnight 5", owner 04/10: was 10; 20 on Saturday), name, lastNight.topN -- rows, the "#N is at"
 *   label and the final-standings line follow topN; the Liquid renders the matching ladder for the shop date.
 * Refreshes every 5 minutes. Preview: ?lb_mock=1 (sample board) | ?lb_mock=empty (before the first order).
 * Owner 05/10: without an s-id the "See your points" form POSTs {email, order} to the same endpoint (same JSON, me for
 *   that email once the order is proven theirs). A good pair is kept in localStorage ap_tarot_me_lookup and re-POSTed on
 *   every refresh; not_found / bad_input forget it and bring the form back. A known s-id always gives `me`, so those visitors never see the form.
 */
(function () {
  'use strict';
  var root = document.getElementById('atl');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  var REFRESH_MS = 5 * 60 * 1000;
  var SID_KEY = 'ap_tarot_sid';
  var SID_RE = /^[A-Za-z0-9_-]{1,64}$/;
  var EMPTY = 'The board fills in as orders come in. Tonight\u2019s race closes at midnight.';
  var params = new URLSearchParams(location.search);
  var MOCK = params.get('lb_mock') || '';
  var ENDPOINT = root.getAttribute('data-endpoint') || '/apps/afp-analytics/tarot/leaderboard';

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  var sid = (params.get('s-id') || '').trim();
  var urlSid = SID_RE.test(sid);
  if (urlSid) { if (!MOCK) lsSet(SID_KEY, sid); }
  else { sid = lsGet(SID_KEY) || ''; if (!SID_RE.test(sid)) sid = ''; }

  // Owner 05/10: email + order number lookup for visitors the s-id does not identify (none, or one Postscript
  // does not know). A fresh s-id in the link wins over a remembered pair.
  var LOOK_KEY = 'ap_tarot_me_lookup';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
  var ORDER_RE = /^#?\s*(afp)?[\s-]*\d{3,9}$/i;
  var LOOK_BAD = 'Check your email and order number (for example AFP12345).';
  var LOOK_NOT_FOUND = 'We couldn\u2019t find that order with that email.';
  var LOOK_BUSY = 'Something hiccupped. Try again in a moment.';
  var look = null;
  if (!urlSid) {
    try { look = JSON.parse(lsGet(LOOK_KEY) || 'null'); } catch (e) { look = null; }
    if (!look || typeof look.email !== 'string' || typeof look.order !== 'string') look = null;
  }
  function forget() { look = null; lsDel(LOOK_KEY); }

  var $ = function (sel) { return root.querySelector(sel); };
  var board = $('[data-atl-board]');
  var upd = $('[data-atl-upd]');
  var last = null, lastLoad = 0, ended = false, timer = null, endsAt = 0;
  var lookForm = $('[data-atl-look]'), lookMsg = $('[data-atl-look-msg]'), lookBtn = $('[data-atl-look-btn]'), swapBtn = $('[data-atl-me-swap]');
  var clockWrap = $('[data-atl-clock-wrap]'), clockEl = $('[data-atl-clock]');
  function tick() {
    var ms = endsAt - Date.now();
    if (!endsAt || ms <= 0) { clockWrap.hidden = true; return; }
    var s = Math.floor(ms / 1000), h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60); s = s % 60;
    clockEl.textContent = h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    clockWrap.hidden = false;
  }
  setInterval(tick, 1000);
  function dayName(day) {
    var d = new Date(day + 'T12:00:00Z');
    try { return d.toLocaleDateString('en-US', { timeZone: 'UTC', weekday: 'long', month: 'short', day: 'numeric' }); } catch (e) { return day; }
  }

  var num = function (x) { return Number(x).toLocaleString('en-US'); };
  function ptTime(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    try { return d.toLocaleTimeString('en-US', { timeZone: 'America/Los_Angeles', hour: 'numeric', minute: '2-digit' }); }
    catch (e) { return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }); }
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function row(r, me, topN) {
    var rank = Number(r.rank);
    var li = el('li', (rank <= 3 ? 'top3' : '') + (rank > (topN || 20) ? ' out' : '') + (me && Number(me.rank) === rank ? ' is-me' : ''));
    li.appendChild(el('span', 'r', String(rank)));
    var n = el('span', 'n');
    n.appendChild(el('b', null, r.name || ''));
    n.appendChild(el('span', null, r.place || ' '));
    li.appendChild(n);
    li.appendChild(el('span', 'p', num(r.points || 0)));
    return li;
  }

  // Owner 04/10: the ladder for the API's topN as well, in case this page's HTML was cached on the other day.
  var LADDER = {
    5: { sub: 'Every $1 you spend today = 1 point. At midnight tonight the top 5 win.', // owner 04/10: The Midnight 5
          rows: [['#1', '$200 cash back + two Halloween sets + a silk scarf'], ['#2 and #3', 'two Halloween sets + a silk scarf'], ['#4 and #5', 'a Halloween set + a silk scarf']] },
    20: { sub: 'Every $1 you spend today = 1 point. At midnight the top 20 win, then a new race starts.',
          rows: [['#1', '$100 cash back + Halloween set + silk scarf'], ['#2\u20133', 'Halloween set + silk scarf'], ['#4\u201320', 'Halloween set (dress + leggings)']] }
  };
  var ladderN = 0;
  function paintLadder(n) {
    var L = LADDER[n], ul = root.querySelector('.atl__ladder'), sub = root.querySelector('.atl__sub');
    if (!L || !ul || ladderN === n) return;
    ladderN = n;
    if (sub) sub.textContent = L.sub;
    ul.textContent = '';
    L.rows.forEach(function (r) { var li = el('li'); li.appendChild(el('b', null, r[0])); li.appendChild(el('span', null, r[1])); ul.appendChild(li); });
  }

  function render(d) {
    var me = d.me && typeof d.me === 'object' ? d.me : null;
    var cutoff = Number(d.cutoff);
    var topN = Number(d.topN) || 20;
    // Hooks below are absent until the new snippet is pushed, hence the guards.
    var cutL = $('[data-atl-cut-l]'), h1 = $('[data-atl-h1]'), bar = $('[data-atl-bar]');
    if (cutL) cutL.textContent = '#' + topN + ' is at';
    if (d.topN) paintLadder(topN);
    if (d.name) { if (h1) h1.textContent = d.name; if (bar) bar.textContent = 'Halloween Private Sale \u00b7 ' + d.name; }
    var meBox = $('[data-atl-me]');
    meBox.hidden = !me;
    if (lookForm) lookForm.hidden = !!me; // a known s-id always gives me (0 points before a first order)
    if (swapBtn) swapBtn.hidden = !(me && look);
    if (me) {
      var pts = Math.max(0, Number(me.points) || 0), rk = Number(me.rank);
      $('[data-atl-me-v]').textContent = num(pts) + ' points' + (rk > 0 ? ' · #' + num(rk) : '');
      $('[data-atl-cut]').hidden = !(cutoff > 0);
      $('[data-atl-cut-v]').textContent = cutoff > 0 ? num(cutoff) : '';
    }

    ended = !!d.endsAt && Date.now() > Date.parse(d.endsAt);
    endsAt = ended ? 0 : (Date.parse(d.endsAt) || 0); tick();
    // Owner 04/10: after the last race the sub must not invite people to "midnight tonight".
    var subEl = root.querySelector('.atl__sub');
    if (ended && subEl) subEl.textContent = 'The race is over. The top ' + topN + ' won.';
    var lastBox = $('[data-atl-last]'), ln = d.lastNight && Array.isArray(d.lastNight.top) && d.lastNight.top.length ? d.lastNight : null;
    lastBox.hidden = !ln || ended;
    if (ln && !ended) {
      $('[data-atl-last-h]').textContent = dayName(ln.day) + ' \u00b7 winners';
      var lb = $('[data-atl-last-board]'); lb.textContent = '';
      var lnN = Number(ln.topN) || 20; var ol = el('ol'); ln.top.slice(0, lnN).forEach(function (r) { ol.appendChild(row(r, null, lnN)); }); lb.appendChild(ol); // owner 04/10: every winner of last night, not just 15
    }
    var t = ptTime(d.updatedAt);
    upd.textContent = ended ? 'Final standings \u00b7 the top ' + topN + ' win' + (t ? ' · updated ' + t : '')
      : (t ? 'Updated ' + t + ' · ' : '') + 'refreshes every 10 minutes';

    board.textContent = '';
    // Owner 03/10 ~23:00 VN: only the winners (#1..#topN; owner 04/10: 5 on Sunday), one compact line each, so the board fits one phone screen.
    var top = (Array.isArray(d.top) ? d.top : []).filter(function (r) { return Number(r.rank) <= topN; }).sort(function (a, b) { return a.rank - b.rank; });
    if (!top.length) { board.appendChild(el('p', 'atl__state', EMPTY)); return; }
    var inside = el('ol');
    top.forEach(function (r) { inside.appendChild(row(r, me, topN)); });
    board.appendChild(inside);
  }

  function mock() {
    if (MOCK === 'empty') return Promise.resolve({ ok: true, updatedAt: new Date().toISOString(), endsAt: '2026-10-05T06:59:00Z', cutoff: null, top: [], me: null });
    var names = [['G***a B.', 'Miami, FL', 612], ['T***y T.', 'Long Beach, CA', 540], ['H***r H.', 'Tacoma, WA', 497], ['L***a L.', 'Medford, OR', 455], ['K***n K.', 'Hillsborough, NC', 431]];
    var cities = ['Atlanta, GA', 'Houston, TX', 'Chicago, IL', 'Dallas, TX', 'Newark, NJ', 'Memphis, TN', 'Baltimore, MD', 'Columbus, OH'];
    var top = [];
    for (var i = 1; i <= 35; i++) {
      var f = names[i - 1];
      top.push(f ? { rank: i, name: f[0], place: f[1], points: f[2] }
        : { rank: i, name: 'ABCDEFGHJKLMNPRSTW'.charAt(i % 18) + '***' + 'aeiny'.charAt(i % 5) + ' ' + 'MJWPBCDT'.charAt(i % 8) + '.', place: cities[i % cities.length],
            points: i <= 30 ? Math.round(431 - (i - 5) * (431 - 186) / 25) : [179, 171, 163, 156, 150][i - 31] });
    }
    var tonight = new Date(Date.now() + 5 * 3600000 + 12 * 60000).toISOString();
    return Promise.resolve({ ok: true, day: '2026-10-04', updatedAt: new Date(Date.now() - 3 * 60000).toISOString(), endsAt: tonight, cutoff: 186, top: top, me: { points: 142, rank: 41 },
      lastNight: MOCK === '2' ? { day: '2026-10-03', top: top.slice(0, 30) } : null });
  }

  function get() {
    return fetch(ENDPOINT + (sid ? '?sid=' + encodeURIComponent(sid) : ''), {
      credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store'
    }).then(function (r) { return r.json(); });
  }
  function post(body) {
    return fetch(ENDPOINT, {
      method: 'POST', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  // Re-POST the remembered pair; a pair that no longer matches is dropped and the plain board is shown.
  function viaLookup() {
    return post(look).then(function (d) {
      if (d && d.ok === true) return d;
      if (d && (d.error === 'not_found' || d.error === 'bad_input')) forget();
      else if (last) throw new Error('lookup busy'); // keep the last board and points on screen
      return get();
    });
  }

  function load() {
    lastLoad = Date.now();
    var p = MOCK ? mock() : (look ? viaLookup() : get());
    p.then(function (d) {
      if (!d || d.ok !== true) throw new Error('bad payload');
      last = d;
      render(d);
      if (ended && timer) { clearInterval(timer); timer = null; }
    }).catch(function () {
      if (!last) { board.textContent = ''; board.appendChild(el('p', 'atl__state', 'The board is catching its breath. It will refresh in a few minutes.')); }
      else upd.textContent = 'Couldn’t refresh just now. Trying again shortly.';
    });
  }

  function say(msg) {
    if (!lookMsg) return;
    lookMsg.textContent = msg || '';
    lookMsg.hidden = !msg;
  }
  if (lookForm) {
    lookForm.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = String(lookForm.elements.email.value || '').trim();
      var order = String(lookForm.elements.order.value || '').trim();
      if (!EMAIL_RE.test(email) || !ORDER_RE.test(order)) { say(LOOK_BAD); return; }
      say('');
      lookBtn.disabled = true;
      post({ email: email, order: order }).then(function (d) {
        if (d && d.ok === true) {
          look = { email: email, order: order };
          lsSet(LOOK_KEY, JSON.stringify(look));
          last = d; lastLoad = Date.now();
          render(d);
          return;
        }
        say(d && d.error === 'not_found' ? LOOK_NOT_FOUND : d && d.error === 'bad_input' ? LOOK_BAD : (d && d.message) || LOOK_BUSY);
      }).catch(function () { say(LOOK_BUSY); }).then(function () { lookBtn.disabled = false; });
    });
  }
  if (swapBtn) {
    swapBtn.addEventListener('click', function () {
      forget();
      if (last) { last.me = null; render(last); }
      if (lookForm) { lookForm.elements.order.value = ''; lookForm.elements.email.focus(); }
    });
  }

  load();
  timer = setInterval(function () { if (!document.hidden) load(); }, REFRESH_MS);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && !ended && Date.now() - lastLoad > REFRESH_MS) load();
  });
})();
